export default __webpack_public_path__ + "static/media/005-moose.a5b5eec6.svg";